import React from 'react'

import { OrderSyncErrorCell } from './OrderSyncErrorCell'

import { MyRowProps } from '../../types/tableTypes'
import { WbOrderModel } from '../../server/mpsklad_core/Models/Orders/WbOrderModel'

export const WbOrderSyncErrorCell =
  ({row}: MyRowProps<WbOrderModel>) =>
    <OrderSyncErrorCell type={'Wildberries'} row={row}/>